import React from 'react';
import DrawerBase from '@mui/material/Drawer';

const Drawer = (props) => {
  return <DrawerBase {...props} />;
};

export default Drawer;
